import "./Contacts.module.css";
import Header from "@/reusable_sections/Header";
import Contact from "./sections/Contact";
import Location from "./sections/Location";
import InviaUnMessaggio from "./sections/InviaUnMessaggio";
import Footer from "@/reusable_sections/Footer";
export default function ContactsPage() {
  return <div>
      <Header />
      <Contact />
      <Location />
      <InviaUnMessaggio />
      <Footer />
    </div>;
}